<template>
  <div class="invest">
    <Header></Header>
      <div class="invest-banner flex-row">
        <div class="container business-banner-title">
          <p>产业精准招商</p>
          <p>
            中产集团为各级政府园区提供精准招商服务，以数智化方式定向开发符合产
          </p>
          <p>业发展需求的优质项目。</p>
        </div>
      </div>
      <div class="invest-invest flex-row">
        <div class="container invest-intro">
          <p>行业首创“一对一”服务，精准对接、快速落地</p>
          <p>中产集团行业内首创“一对一”服务，通过前期沟通认可后安排政企精准</p>
          <p>对接，对接满意后安排双向考察，推动项目快速落地。</p>
          <br /><br /><br />
          <img
            class="wow animate__animated animate__rotateIn"
            data-wow-delay=".1s"
            data-wow-offset="10"
            src="@/assets/images/business/invest1.png"
            alt=""
          />
          <img
            class="wow animate__animated animate__rotateIn"
            data-wow-delay=".2s"
            data-wow-offset="10"
            style="margin-left:-100px"
            src="@/assets/images/business/invest2.png"
            alt=""
          />
          <img
            class="wow animate__animated animate__rotateIn"
            data-wow-delay=".3s"
            data-wow-offset="10"
            style="margin-left:-100px"
            src="@/assets/images/business/invest3.png"
            alt=""
          />
          <img
            class="wow animate__animated animate__rotateIn"
            data-wow-delay=".4s"
            data-wow-offset="10"
            style="margin-left:-100px"
            src="@/assets/images/business/invest4.png"
            alt=""
          />
        </div>
      </div>
      <div class="invest-area flex-row">
        <div class="container area-intro flex-col">
          <p>数智化招商，赋能区域产业发展</p>
          <p>中产集团突破传统政府招商以及第三方招商1.0模式弊端，集成“1+5”特</p>
          <p>色生态服务，营造独特优势，以精准招商赋能产业发展。</p>
        </div>
      </div>
      <div class="invest-advantage flex-row">
        <div class="container flex-col">
          <div class="flex-row advantage-intro">
            <div class="invest-left">
              <p>政府招商引资现状</p>
              <p>优质精准项目线索难找</p>
              <p>与投资企业信息不对称</p>
              <p>小分队招商效果不明显</p>
              <p>培养专业团队成本太高</p>
            </div>
            <div class="invest-right">
              <p>
                <img
                  src="@/assets/images/business/invest-arrow.png"
                  alt=""
                />&nbsp;数智化招商优势
              </p>
              <div class="invest-right-bottom flex-row">
                <img
                  style="margin-right:20px"
                  height="180"
                  src="@/assets/images/business/invest-earth.png"
                  alt=""
                />
                <div>
                  <p>专业的人做专业的事，节约时间和人力成本</p>
                  <p>定制化服务，精准匹配，政企一对一交流</p>
                  <p>两条腿走路，效率更高</p>
                  <p>专注优化营商环境，提高区域竞争力</p>
                </div>
              </div>
            </div>
          </div>
          <br /><br /><br />
          <div class="flex-row advantage-intro">
            <div class="invest-left">
              <p style="margin-bottom: 24px;">信息中介招商现状</p>
              <p style="line-height:36px;margin-bottom: 14px;">
                产业匹配盲目，营销过渡，项目把关粗糙
              </p>
              <p style="line-height:36px;margin-bottom: 14px;">
                一对多，政府拼政策、抢项目，落地难
              </p>
              <p style="line-height:36px;margin-bottom: 14px;">
                基金募投管退经验不足
              </p>
              <p style="line-height:36px">优质项目资源匮乏</p>
            </div>
            <div class="invest-right">
              <p>
                <img
                  src="@/assets/images/business/invest-arrow.png"
                  alt=""
                />&nbsp;中产集团数智化招商优势
              </p>
              <div class="invest-right-bottom flex-row">
                <img
                  style="margin-right:20px"
                  height="180"
                  src="@/assets/images/business/invest-building.png"
                  alt=""
                />
                <div>
                  <p>中产智库、产业研究院、专业产业基金团队</p>
                  <p>一对一服务，政策投入少，项目落地快</p>
                  <p>两支基金险资牌照，在管基金超百亿</p>
                  <p>上海星动力高端企业家资源导入</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invest-efficient">
        <div class="container">
          <p class="efficient-title">三大核心优势，产业招商精准高效</p>
          <el-carousel indicator-position="none" arrow="never" :interval="4000" type="card" height="600px">
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient1.png" alt="" />
                <div class="efficient-intro">中产集团旗下拥有近400人大数据团队，实时抓取全球投资意向活跃的企业资源。大数据研发基地已接待多位中央及省部级领导考察、调研。</div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient2.png" alt="" />
                <div class="efficient-intro">中产集团具有<span>险资LP管理资质</span>，累计管理基金规模超<span>300亿元</span>，合作产业投资机构近<span>300家</span>；以资金配套服务减轻政府财政压力，推动优质项目顺利竣工、达产。</div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient3.png" alt="" />
                <div class="efficient-intro">中产集团旗下上海星动力科创空间在10000平米场域内每年吸引2万家知名企业到访，大型央企、国企、行业500强及知名上市公司核心高层资源对接。</div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient1.png" alt="" />
                <div class="efficient-intro">中产集团旗下拥有近400人大数据团队，实时抓取全球投资意向活跃的企业资源。大数据研发基地已接待多位中央及省部级领导考察、调研。</div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient2.png" alt="" />
                <div class="efficient-intro">中产集团具有<span>险资LP管理资质</span>，累计管理基金规模超<span>300亿元</span>，合作产业投资机构近<span>300家</span>；以资金配套服务减轻政府财政压力，推动优质项目顺利竣工、达产。</div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="efficient-item">
                <img src="@/assets/images/business/efficient3.png" alt="" />
                <div class="efficient-intro">中产集团旗下上海星动力科创空间在10000平米场域内每年吸引2万家知名企业到访，大型央企、国企、行业500强及知名上市公司核心高层资源对接。</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="invest-service">
          <p class="service-title">项目落地全流程服务</p>
          <div class="service-subtitle">打通项目落地最后一公里，让招商更容易</div>
          <div class="container" style="margin-top:100px">
            <img src="@/assets/images/business/progress.png" alt="">
            <div class="flex-row progress">
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay=".1s" data-wow-offset="10">
                <p>项目筛选</p>
                <p>对项目方进行专业筛选、评估、背景调查</p>
              </div>
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay=".2s" data-wow-offset="10">
                <p>项目对接</p>
                <p>安排政企“一对一”精准项目对接会</p>
              </div>
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay=".3s" data-wow-offset="10">
                <p>项目考察</p>
                <p>安排政企进行双向考察，洽谈落地合作</p>
              </div>
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay=".4s" data-wow-offset="10">
                <p>项目签约</p>
                <p>协助推进项目快速签约</p>
              </div>
              <div class="wow animate__animated animate__fadeInUp" data-wow-delay=".5s" data-wow-offset="10">
                <p>签约后服务</p>
                <p>中产资本可以为企业提供资金配套服务</p>
              </div>
            </div>
          </div>
      </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/invest.css";
import Header from './Header'
import Footer from './Footer'
export default {
  name: "Invest",
  components:{
    Header,Footer
  },
  data() {
    return {
      current:'',
      };
  },
  created(){
    this.current=this.$route.params.subtitle
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Invest.vue